const caracter = "(*)";
const messages = {
  caracter: caracter,
  title_close: "Salir",
  title_system_close: "cerrar sesión",
  title_home: "Inicio",
  title_filter: "Filtros de datos",
  title_system: "SISTEMA DE RECAUDACIONES (SRE)",
  title_system_min: "RECAUDACIONES (SRE)",
  title: "Recaudaciones",
  loginUsernameExistError:
    "El usuario ingresado no existe, favor verifique sus datos.",
  loginADSuccessAwait: "Estamos iniciando su sesión, espere por favor.",
  loginADRedirect: "Redireccionando...",
  logoutUser: "Sesión Finalizada",
  lblSimbolo: "El símbolo " + caracter,
  lblfieldsRequired:
    "indica los campos mínimos requeridos para poder procesar el formulario",
  lblSingleSelect: "Seleccione algun item",
  lblSingleTypeSelect: "Seleccione algun pago",
  lblLoading: "Cargando datos",
  lblLoadingSave: "Guardando datos",
  lblFunctions: "Opciones",
  lblName: "Nombre",
  lblCode: "Código",
  lbEdit: "Editar",
  lbDetail: "Detalle",
  lbBack: "Regresar",
  lbUsername: "Usuario: ",
  lbRoleName: "Rol: ",
  lbAll: "Todos",
  lblYes: "Si",
  lblNo: "No",
  lbAllowCreate: "Permitir Crear",
  lbAllowRead: "Permitir Ver",
  lbAllowUpdate: "Permitir Actualizar",
  lbAllowDelete: "Permitir Eliminar",
  lbMultipleSelect: "Seleccion multiple",
  lbSelectedRoleType: "Seleccionar Transacciones",
  lbSelectDefault: "Seleccionar por Defecto",
  lblSessionExpireIn: "La sesión expirara en: ",
  success_reload_data: "Los datos han sido actualizados",
  success_clean_data: "Se ha reiniciado el formulario",
  await_logout_session: "Estamos cerrando su sesion...",
  btnDisable: "Dar de Baja",
  btnVerify: "Verificar",
  lblConciliationMonitor: "Conciliación Bancaria e Intermedio",
  lblCardTitleBank: "Banco",
  lblCardTitleIncome: "SISTEMA DE RECAUDACIONES",
  lblCardTitleTotalConciliation: "CONCILIADO",
  lblCardTitleConciliationError: "DIFERENCIA",
  tabConciliationDaily: "Conciliación Diaria",
  tabConciliationHistory: "Histórico",
  tabConciliationDailyBank: "Entidad Bancaria",
  tabConciliationDailyIncome: "Sistema Recaudaciones",
  //sessionUser
  sessionUser: {
    lbTitle: "Tu sesión se cerrará en",
    lbSeconds: "segundos",
    btnLive: "Mantener Sesión",
    btnDeath: "Cerrar Sesión",
  },
  //switch
  switchOption: {
    daily: "Actual",
    history: "Histórico",
    msmDaily: "Ver Conciliación Diaria",
    msmHistory: "Ver Conciliación Histórica",
    msmEmptySociety:
      "Para ver el Historial debe seleccionar una Sociedad y la Entidad Bancaria",
    lblDateIssue: "Fecha Conciliación",
  },
  //paginacion
  rowsPerPageText: "Filas por página",
  rangeSeparatorText: "de",
  selectAllRowsItemText: "Todos",
  //mensajes
  msmRegisterSuccessFully: "Se registro exitosamente",
  msmUpdated: "El registro fue actualizado correctamente",
  msmRegister: "El valor {0}, fue registrado correctamente",
  msmDeleteDataLoading: "Eliminando datos espere por favor",
  msmDeleteDataSuccess: "Datos Eliminados correctamente",
  msmRegisterDataLoading: "Registrando datos espere por favor",
  msmRegisterDataSuccess: "Datos Registrados correctamente",
  msmDataLoading: "Cargando datos espere por favor",
  msmDisableAll: "Los items seleccionados fueron deshabilitados correctamente",
  msmSendPayments:
    "Los pagos seleccionados fueron enviados correctamente a SAP",
  msmLoadingTotalConciliationDaily:
    "Espere por favor, estamos generando la conciliación diaria",
  msmErrorServer:
    "Ocurrió un error en la respuesta del servidor, por favor consulte con el administrador",
  //errores
  error_required: "El campo no puede estar vacio",
  error_no_selected: "Debe elegir un item",
  error_min_length: "Mínimo {0} carácteres",
  error_max_length: "Máximo {0} carácteres",
  error_email: "Correo no valido",
  error_numero: "El valor debe ser numérico",
  error_greatherThan: "El valor debe ser mayor que {0}",
  error_module: "Ocurrio un error al cargar los modulos",
  error_menu: "Ocurrio un error al cargar el menu del usuario",
  error_node:
    "Ocurrio un error al cargar las transacciones asignadas al usuario",
  error_empty_import_file: "No se importaron los datos, el archivo esta vacio",
  error_invalid_data_import_file:
    "Datos no validos en el documento, revise la pestaña Errores",
  error_invalid_data_row: "Datos no validos en la fila: ",
  error_invalid_SAP:
    "Solo debe seleccionar una solicitud para registrar el código SAP",
  error_exist_data_row: "Fila: ",
  error_empty_data_row: "Datos vacios en la fila: ",
  //info messages
  msmErrorExistRoleName: "El Rol ya fue registrado",
  msmErrorExistSystemName: "El nombre del Sistema ya fue registrado",
  msmErrorExistUserSocietyName: "El usuario ya tiene la sociedad asignada",
  msmErrorExistConnection:
    "Ya existe una coneccion para el banco en esta sociedad y ambiente",
  msmErrorExistCollectingEntity: "La Entidad Recaudadora ya fue registrada",
  msmErrorExistUserRole: "El usuario ya tiene asignado un rol",
  msmErrorOnlyTransactions: "Por favor seleccione solo transacciones",
  msmFatherIdNoValid: "Por favor solo seleccione los submenus",
  msmRoleIdEmpty: "No selecciono ningun Rol",
  msmRestrictedAccessView: "No tiene permisos para visualizar los datos",
  msmRestrictedAccessDelete: "No tiene permisos para eliminar los datos",
  msmRestrictedAccessCreate: "No tiene permisos para crear datos",
  msmMenuDirectoryNotEmpty:
    "Elimine todos los submenus para proceder a la eliminacion del Directorio",
  msmTransactionIdEmpty: "No selecciono ninguna Transaccion",
  msmDataExist: "Valores existentes",
  msmErrorExist: "Error en la respuesta",
  msmErrorForm: "Tiene errores en el formulario",
  msmEmptySelectedTransactionsForm:
    "Seleccionar Transacciones es requerido, seleccione una opcion",
  msmOneDataDisabled: "Seleccione solo un registro por favor",
  msmEmptyDataDisabled: "Seleccione un registro por favor",
  msmCurrentUserDisabled:
    "No se puede eliminar las sociedades del usuario con la sesion actual",
  msmCurrentUserModify: "No se puede modificar al usuario con la sesion actual",
  msmDeleteAll: "Los items seleccionados fueron eliminados correctamente",
  successCleanData: "Se limpiaron los datos",
  msmLoading: "Cargando...",
  msmSelectOptionRole: "Seleccione un rol de la Lista",
  msmExistRegister: "Registro existente",
  msmSociety: "Debe seleccionar primero una sociedad",
  //forms
  btnSave: "Guardar",
  btnEdit: "Editar",
  btnClear: "Limpiar",
  btnReload: "Recargar",
  btnRestart: "Reiniciar",
  btnAssign: "Añadir",
  btnClose: "Cerrar",
  titleUserRoleForm: "Usuario Rol",
  titleRoleForm: "Asignacion de Roles",
  titleSystemForm: "Sistemas",
  titleUserSocietyForm: "Usuario Sociedad",
  titleCEntityForm: "Entidad Recaudadora",
  titleMoney: "Moneda",
  titleEnvironment: "Ambiente",
  titleTypePayment: "Forma de Pago",
  titleTypeForm: "Tipos",
  titleChannelEntityPaymentForm: "Formas de Pago por Entidad",
  titleMessages: "Mensajes",
  titleTabForm: "Formulario",
  titleTabDetailForm: "Registrar Transaccion",
  labelSymbol: "El símbolo " + caracter,
  labelSymbolRequired:
    "indica los campos mínimos requeridos para poder procesar el formulario",
  labelMenu: "Menu",
  placeholderMenu: "menus",
  labelSystem: "Sistema",
  placeholderSystem: "sistemas",
  labelCode: "Codigo",
  labelName: "Nombre Rol",
  labelSystemName: "Nombre Sistema",
  labelCEntityName: "Nombre Entidad",
  labelTypeName: "Nombre Tipo",
  labelDescription: "Descripcion",
  labelAddress: "Direccion/Ruta",
  labelCountry: "Pais",
  labelSocieties: "Sociedad",
  labelMessage: "Mensaje",
  labelEmail: "E-mail",
  labelUsers: "Usuario",
  labelNotAssignedTransactions: "Asignar Transacciones",
  labelRoles: "Rol",
  labelAddTransaction: "Añadir Transacciones",
  labelAddTransactionFolder: "Añadir DIrectorio",
  labelDeleteTransaction: "Eliminar Transaccion",
  labelDeleteTransactionFolder: "Eliminar Directorio",
  labelAddMenu: "Seleccione Grupo Rol",
  labelQuantityVoucher: "Cantidad Facturas",
  labelHost: "Host",
  labelUser: "Usuario",
  labelPassword: "Contraseña",
  labelPath: "Path",
  titleConnectionSftp: "Conecciones SFTP registradas",
  //grid
  gridRoleTitle: "Lista de Roles",
  gridUserRoleTitle: "Lista de Usuarios Roles",
  gridUserRoleDescriptionTitle: "Detalle Usuario Rol",
  gridSystemTitle: "Lista de Sistemas",
  gridUserSocietyTitle: "Sociedades asignadas a Usuario",
  gridCEntitiesTitle: "Lista Entidades Recaudadoras",
  gridTypeTitle: "Lista de Tipos",
  gridChannelEntityPaymentTitle: "Lista de Formas de Pago",
  gridMessagesTitle: "Lista de Mensajes",
  gridColumUserName: "Nombre Usuario",
  gridColumRoleName: "Nombre Rol",
  gridColumRoleCode: "Codigo",
  gridColumSystemName: "Nombre Sistema",
  gridColumSystemDescription: "Descripcion",
  gridColumCEntityName: "Nombre Entidad",
  gridColumCEntityCode: "Codigo",
  gridColumCEntityCountry: "Pais",
  gridColumCEntitySocietyId: "Sociedad",
  gridColumCEntityReplicationTime: "Replicacion (min)",
  warning_required_field: "El campo es requerido",
  warning_required_field_small: "Requerido",
  warningOnlyNumeric: "Solo se permite números enteros",
  warningOnlyNumericSmall: "Solo números",
  warningOnlyDecimales: "Solo se permite numeros decimales",
  warningOnlyNumericOrDecimal: "Solo se permite numeros enteros o decimales",
  warningOnlyEmail: "No es un email valido",
  warningOnlyIP: "No es una direccion IP valida",
  warningMinimumLength: "El nombre debe tener mas de 3 caracteres",
  society: {
    title_society: "Sociedades",
    title_society_register: "Sociedades Registradas",
    errorCode: "Max. 4 caracteres",
    errorRegister: "El código o nombre de la sociedad ya fue registrado",
    lblsociety: "Sociedad",
  },
  collectingEntity: {
    title_collecting_entity: "Entidad Recaudadora",
    replication_time: "Replicación",
    Entity: "Entidad",
    society: "Sociedad",
    country: "País",
    time: "Rep. (min.)",
    code: "Código",
    name: "Razón social",
    down: "Dar de Baja",
  },
  documentType: {
    title_document_type: "Tipos de documentos",
    title_document_type_register: "Tipos de documentos asignados",
    errorCode: "Max. 4 caracteres",
    errorRegister: "Ocurrio un error al registrar",
  },
  country: {
    title_country: "País",
    title_country_form: "Registro de paises",
    title_country_register: "Paises Registrados",
    title_type_payment: "Tipo Pago",
  },
  transaction: {
    title: "Registro de transacciones",
    route: "Ruta",
    table: "Transacciones",
  },
  type: {
    title: "Registro",
    createConcept: "Concepto",
    selectConcept: "Tipo",
    titlePayment: "Tipo de Recaudacion",
    titleGrid: "Tipos registrados",
    concept: "Concepto: ",
    name: "Nombre",
    code: "Código",
    value: "Valor",
    nameConcept: "Nombre de concepto",
  },
  message: {
    typeMessage: "Tipo",
    nameMessage: "Nombre",
    descriptionMessage: "Descripción",
    codeMessage: "Código",
  },
  channelTransaction: {
    title_channel_transaction: "Transacciones por Canal",
    title_document_type_register: "Transacciones por canal asignados",
    errorRegister: "Ocurrio un error al registrar",
    time_expiration: "Tiempo de expiración (Minutos)",
    time_null: "Tiempo de anulación (Minutos)",
    lbl_annulation: "Anulación(min)",
    lbl_expiration: "Expiración(min)",
  },
  login: {
    label_email: "Correo Electrónico",
    label_pass: "Contraseña",
    label_confirmation: "Confirmación",
    title_change_pass: "Ha olvidado la contraseña?",
    title_create: "Aun no tienes una cuenta?",
    lbl_change_pass: "Cambiar contraseña",
    lbl_create_account: "Crear Cuenta",
    lbl_send: "Enviar Confirmación",
    lbl_code: "Código de Confirmación",
    lbl_new_pass: "Nueva contraseña",
    lbl_new_pass_conf: "Confirmar Contraseña",
    lbl_sign_in: "Iniciar sesión",
    message_create: "Usuario creado",
    error_create: "Los datos del usuario no han sido registrados",
    message_login:
      "Registrando datos de ingreso, espere para ser redireccionado",
    message_login_success: "Credenciales de acceso validas, cargando datos",
    message_pass_success: "Su contraseña ha sido cambiada.",
    message_pass_login: "Click aqui para iniciar con su nueva contraseña.",
    message_send_code: "El código ha sido enviado a su correo",
    message_check_email: "Por favor revise su correo electrónico.",
    error_auth: "Ocurrio un error al autentificarse.",
  },
  branch: {
    title: "Sucursales",
    error_list: "No tiene acceso a los datos",
    lbl_phone: "teléfono",
    lbl_address: "dirección",
    title_register: "Sucursales registradas",
    lblCod: "Cod.",
  },
  channel: {
    title: "Canales por entidad",
    lblChannel: "Canal",
    titleList: "Canales registrados",
    lblCod: "Cod.",
    lblCant: "Cant.",
    register: "Registro",
  },
  paginationOptions: {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  },
  roleConcept: {
    title: "Conceptos por Rol",
    titleTable: "Conceptos asignados a Roles",
  },
  account: {
    lblAccount: "Cuenta",
    lblCurrency: "Moneda",
    lblNote: "Descripción",
    title: "Cuentas por entidad",
    title_register: "Cuentas habilitadas",
  },
  monitor: {
    lblCustomerType: "Tipo de Cliente",
    lblNote: "Nota:",
    lblDateIni: "Fecha inicio",
    lblDateEnd: "Fecha fin",
    lblState: "Estados",
    lblClient: "Clientes",
    lblSearch: "Buscar",
    lblAll: "Todos",
    lblTrace: "Trace",
    lblEntity: "Entidad",
    lblClientData: "Cliente",
    lblBranch: "Sucursal",
    lblDate: "Fecha Origen",
    lblDateIn: "Registro",
    lblDateOperation: "Fecha de operación",
    lblChannel: "Canal",
    clState: "Estado",
    title_monitor: "Monitor de Operaciones",
    title: "Pagos de la transacción",
    lblBill: "Partida Abierta",
    lblTotaalBill: "Total partida",
    colUnitPrice: "Monto Pagado",
    lblTotal: "Total",
    lblCoin: "Moneda",
    check: "Cheque",
    send: "Enviar Pagos",
    sap: "Cod.Deudor",
    export: "Exportar resumen",
    msmExport:
      "Al exportar datos se limpiará la pantalla del monitor de operaciones. ",
  },
  sendPayments: {
    title_monitor: "Envio de pagos a SAP",
  },
  client: {
    title: "Clientes",
    lblSearch: "Buscar",
    lblFilter: "Nombre o Código",
    lblName: "Nombre",
    lblCountry: "País",
    lblCode: "Código",
    lblTypeDocument: "T. Documento",
    lblDocument: "Doc. Identidad",
    filter: "Filtro",
    lblCodeSap: "Cod. Deudor SAP",
    state: "Activo",
  },
  conciliation: {
    title: "Resumen de partidas abiertas",
    lbDate: "Fecha",
    society: "Sociedad",
    type: "Tipo",
    resumen: "Resumen",
    lblDateIn: "Fecha",
    lblClientData: "Cliente",
    code: "Cód.Deudor SAP",
    document: "Documento SAP",
    amount: "Importe",
    year: "Ejercicio",
    lblCoin: "Moneda",
    empty: "No existen datos para los filtros seleccionados",
    search: "Buscar",
    file: "ARCHIVO",
    export: "Exportar (CSV)",
    notEquals:
      "Se encontró una diferencia de montos, por favor verifique los comprobantes",
  },
  limitAmount: {
    lblMinAmount: "Mínimo",
    lblMaxAmount: "Máximo",
    gridAmountEntityTitle: "Rangos de pago por Entidad",
    titleAmountEntityForm: "Min. y Max. por Entidad",
    error: { maxValue: "Valor máximo incorrecto" },
  },
  gridConciliationDaily: {
    lbConciliationSocietyDaily: "Conciliación Bancaria por Sociedad",
    operationNumber: "No.Operacion",
    trace: "Trace",
    clientName: "Nombre",
    clientDni: "CI/DNI/RUC",
    bankName: "Banco",
    channelName: "Canal",
    billNumber: "No. Factura",
    dateIssue: "Fecha",
    amount: "Pago Abono",
    billAmount: "Pago Factura",
    state: "Estado",
    sap: "Cod. Deudor SAP",
    obs: "",
  },
  filterData: {
    plHolderClientName: "nombre del cliente",
    lblClientName: "Cliente",
    plHolderClientCi: "ci, dni o ruc",
    lblClientCi: "DNI",
    lblClientCodeSap: "SAP",
    plHolderClientCodeSap: "codigo SAP",
    plHolderBankName: "nombre entidad bancaria",
    lblBankName: "Banco",
    addOptionFilter: 'Se incluirá "{0}" en la búsqueda',
    removeOptionFilter: 'Se removió "{0}" de la búsqueda',
  },
  template: {
    title: "Plantilla",
    name: "Nombre",
    detail: "Detalle",
    registerData: "Campos registrados",
    lblTemplate: "Plantilla",
    posInitial: "Inicial",
    posEnd: "P. Final",
    long: "Longitud",
    description: "Descripción",
    formatDate: "Formato de Fecha",
    decimalSeparator: "Separador decimal",
    decimalcount: "Cant. decimal",
    sequence: "Secuencia",
    lblsequence: "Sec.",
    lblposInit: "Ini.",
    lblposEnd: "Fin.",
    errorPositionEnd: "Debe ser mayor",
    lbllentgh: "Ln.",
    lblField: "Campo",
    field: {
      name: "Nombre",
      value: "valor",
    },
  },
  templateAssign: {
    assign: "Asignación",
    head: "Cabecera",
    detail: "Detalle",
    foot: "Pie",
    name: "Nombre",
    entity: "Entidad recaudadora",
    separator: "Caracter separador",
    load: "Búscando datos de asignación",
    msmLoad: "Se cargo la configuración: ",
    none: "Ninguno",
  },
  sftp: {
    port: "Puerto",
  },
  footer: {
    contact: "Contacto:",
    develop: "Desarrollado por:",
  },
  lblListRoles: "Roles",
  lblCodeRol: "Codigo",
  lblValueRol: "Valor",
  lblNameRol: "Rol",
  lblNameType: "Tipo",
  lblIdType: "Id",
  lblConcept: "Concepto",
  lblQuantityVouchers: "Cant. Facturas",
  lblTransactionsRol: "Transacciones",
  lblNameTransaction: "Transaccion",
  msgSave: "¿Esta seguro de guardar el registro?",
  msgDelete: "¿Esta seguro de eliminar el registro?",
  codeDuplicated: "Codigo Duplicado",
  messageNoAccessRegister: "No tiene permisos para registrar datos",
  messageNoAccessEdit: "No tiene permisos para editar los datos",
  messageNoAccessRemove: "No tiene permisos para eliminar datos",
  messageNoAccessView: "No tiene permisos para visualizar los datos",
  amountCollectingEntityExist:
    "Ya existen montos definidos para la esta entidad recaudadora y tipo de moneda",
  typePaymentExistChannelCollectingEntity:
    "Ya existen el tipo de pago para el canal de la entidad",
  maxAmountHigherMinAmount: "El monto maximo debe ser mayor al monto minimo",
  messageSelectSociety: "Seleccione una sociedad",
  messageSelectEntity: "Seleccione una entidad",
  messageSelectMoney: "Seleccione una moneda",
  messageSelectChannel: "Seleccione una canal",
  messageSelectTypePayment: "Seleccione un tipo de pago",
  msmAdvanceFilter: "Búsqueda avanzada Activada",
  msmRemoveAdvanceFilter: "Se Desactivo la Búsqueda avanzada",
  msmAddOptionFilter: 'Se incluirá "{0}" en la búsqueda',
  msmRemoveOptionFilter: 'Se removió "{0}" de la búsqueda',
  history: {
    titleHistory: "Historial de Partidas",
    btnSearch: "Buscar",
    btnRestartSearch: "Reiniciar",
    labelDocSAP: "Nro. Documento SAP",
    labelDNIClient: "DNI Cliente",
    labelNameClient: "Nombre Cliente",
    labelDateIssueInit: "Fecha inicio",
    labelDateIssueEnd: "Fecha fin",
    filterSociety: "Sociedad",
    filterAdvanceSearch: "Búsqueda avanzada",
    filterDocSAP: "Doc. SAP",
    filterDNIClient: "DNI/RUC/NIT/CI",
    filterNameClient: "Nombre",
    filterDocumentType: "Tipo",
    filterStatusPaymentType: "Estado",
    gridColumNumberBill1: "Doc. Identidad",
    gridColumNumberBill2: "Referencia",
    gridColumNumberDocumentSap: "Doc. SAP",
    gridHeaderTitlePayment: "Facturas",
    gridColumDocumentType: "Tipo",
    gridColumSocietyName: "Nombre",
    gridColumSAPClient: "Cliente SAP",
    gridColumClientName: "Nombre Cliente",
    gridColumClientCi: "DNI Cliente",
    gridColumAmount: "Monto",
    gridColumAmountClosed: "Vencida",
    gridColumAmountOpen: "Por vencer",
    gridColumCurrencyType: "Moneda",
    gridColumDateIssue: "Fecha Sap",
    gridColumAccountingType: "Estado",
    minColumClientCi: "D.Identidad",
  },
};
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  messages,
};
